import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { HoldToRecordButton } from '../contexts/HoldToRecordContext';
import { getPatientById, getPatientDisplayName } from '../constants/mockPatients';
import { patientPath, ROUTES } from '../constants/routes';
import { useLanguage } from '../contexts/LanguageContext';
import { useSession } from '../contexts/SessionContext';

export default function RecordingScreen() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { t, language } = useLanguage();
  const session = useSession();
  const patient = id ? getPatientById(id, session.admittedPatients) : null;
  const recordingError = location.state?.recordingError;

  useEffect(() => {
    if (!recordingError) return undefined;
    const timer = window.setTimeout(() => {
      navigate(location.pathname, { replace: true, state: {} });
    }, 6000);
    return () => window.clearTimeout(timer);
  }, [location.pathname, navigate, recordingError]);

  return (
    <div className="flex min-h-screen flex-col bg-[#464E59]">
      <div className="flex justify-between px-4 pt-4">
        <button
          type="button"
          onClick={() => navigate(id ? patientPath(id) : ROUTES.PATIENTS)}
          className="flex h-10 w-10 items-center justify-center text-white/90"
          aria-label="Back"
        >
          <ArrowLeft className="h-6 w-6" strokeWidth={2} />
        </button>
      </div>

      {recordingError && (
        <p className="mx-4 mt-2 rounded-xl bg-red-500/20 px-4 py-3 text-center text-sm text-red-100">
          {recordingError}
        </p>
      )}

      {patient && (
        <p className="px-4 text-center text-lg font-medium text-white/90" dir="auto">
          {getPatientDisplayName(patient, language)}
        </p>
      )}

      <p className="px-6 text-center text-sm text-white/70">
        {patient ? t('recordingHintPatient') : t('recordingHintGeneral')}
      </p>

      <div className="flex flex-1 flex-col items-center justify-end px-4 pb-40">
        <p className="record-hint-bottom fixed left-0 right-0 z-[95] px-4 text-center text-sm text-white/80">
          {t('holdToRecord')}
        </p>
        <HoldToRecordButton patientId={id || null} size="fab" />
      </div>
    </div>
  );
}
